import React, { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Container from "@mui/material/Container";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Utils
import { getUproColor } from "utils/colors";

// Assets
import comedorUproLogo from "../../assets/images/comedor.png"; // Adjust the path as necessary

function PantallaMantenimiento() {
  const [tiempo, setTiempo] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTiempo(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatearTiempo = (fecha) => {
    return fecha.toLocaleDateString("es-AR") + " " + fecha.toLocaleTimeString("es-AR");
  };

  const recargarPagina = () => {
    window.location.reload();
  };

  return (
    <SoftBox
      minHeight="100vh"
      sx={{
        background: `linear-gradient(135deg, ${getUproColor("uproBlue")} 0%, ${getUproColor(
          "uproPink"
        )} 100%)`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <Container maxWidth="md">
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} md={8}>
            <Card
              sx={{
                padding: "40px",
                textAlign: "center",
                borderRadius: "20px",
                boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                background: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(10px)",
              }}
            >
              <SoftBox mb={4}>
                <SoftBox
                  component="img"
                  src={comedorUproLogo}
                  alt="Comedor UPrO"
                  style={{
                    width: "200px",
                    height: "auto",
                    maxWidth: "100%",
                    animation: "pulse 2s infinite",
                    filter: `drop-shadow(0 4px 8px ${getUproColor("uproPink")}40)`,
                  }}
                />
                <style jsx>{`
                  @keyframes pulse {
                    0% {
                      transform: scale(1);
                    }
                    50% {
                      transform: scale(1.05);
                    }
                    100% {
                      transform: scale(1);
                    }
                  }
                `}</style>
              </SoftBox>

              <SoftTypography
                variant="h2"
                fontWeight="bold"
                color="dark"
                mb={2}
                sx={{
                  fontSize: { xs: "2rem", md: "3rem" },
                  background: `linear-gradient(45deg, ${getUproColor("uproBlue")}, ${getUproColor(
                    "uproPink"
                  )})`,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Sistema en Mantenimiento
              </SoftTypography>

              <SoftTypography variant="h5" color="text" mb={3} sx={{ opacity: 0.8 }}>
                Estamos trabajando para mejorar tu experiencia
              </SoftTypography>

              <SoftBox mb={4}>
                <SoftTypography variant="body1" color="text" mb={2}>
                  Nuestro sistema está temporalmente fuera de servicio debido a tareas de
                  mantenimiento programado.
                </SoftTypography>
                <SoftTypography variant="body1" color="text" mb={2}>
                  Esperamos estar de vuelta muy pronto con mejoras y nuevas funcionalidades.
                </SoftTypography>
              </SoftBox>

              {/* <SoftBox 
                mb={4} 
                p={3}
                sx={{
                  backgroundColor: "rgba(102, 126, 234, 0.1)",
                  borderRadius: "15px",
                  border: "1px solid rgba(102, 126, 234, 0.2)"
                }}
              >
                <SoftTypography variant="h6" color="dark" mb={1}>
                  <Icon sx={{ verticalAlign: "middle", mr: 1 }}>schedule</Icon>
                  Tiempo actual
                </SoftTypography>
                <SoftTypography variant="h5" color="info" fontWeight="bold">
                  {formatearTiempo(tiempo)}
                </SoftTypography>
              </SoftBox> */}
              {/* 
              <SoftBox mb={3}>
                <SoftButton 
                  variant="gradient" 
                  color="info" 
                  size="large"
                  onClick={recargarPagina}
                  sx={{
                    padding: "12px 30px",
                    fontSize: "16px",
                    borderRadius: "12px",
                    boxShadow: "0 8px 20px rgba(102, 126, 234, 0.3)",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: "0 12px 25px rgba(102, 126, 234, 0.4)"
                    },
                    transition: "all 0.3s ease"
                  }}
                >
                  <Icon sx={{ mr: 1 }}>refresh</Icon>
                  Intentar nuevamente
                </SoftButton>
              </SoftBox> */}

              {/* <SoftBox>
                <SoftTypography variant="body2" color="text" sx={{ opacity: 0.6 }}>
                  Si el problema persiste, contacta al administrador del sistema
                </SoftTypography>
              </SoftBox> */}

              {/* Indicador de carga animado */}
              {/* <SoftBox mt={4}>
                <SoftBox
                  sx={{
                    width: "100%",
                    height: "4px",
                    backgroundColor: "rgba(102, 126, 234, 0.2)",
                    borderRadius: "2px",
                    overflow: "hidden",
                    position: "relative"
                  }}
                >
                  <SoftBox
                    sx={{
                      width: "40%",
                      height: "100%",
                      background: "linear-gradient(45deg, #667eea, #764ba2)",
                      borderRadius: "2px",
                      animation: "loading 2s infinite",
                      "@keyframes loading": {
                        "0%": { transform: "translateX(-100%)" },
                        "50%": { transform: "translateX(250%)" },
                        "100%": { transform: "translateX(-100%)" }
                      }
                    }}
                  />
                </SoftBox>
                <SoftTypography 
                  variant="caption" 
                  color="text" 
                  mt={1}
                  sx={{ opacity: 0.5 }}
                >
                  Verificando estado del sistema...
                </SoftTypography>
              </SoftBox> */}
            </Card>
          </Grid>
        </Grid>
      </Container>
    </SoftBox>
  );
}

export default PantallaMantenimiento;
